import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import GetAppIcon from "@material-ui/icons/GetApp";
import LaunchIcon from "@material-ui/icons/Launch";
const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: "100%",
  },
}));

export default function BookDisplay({
  index = 1,
  title = "",
  authors = [],
  file = "",
  tags = [],
}) {
  const classes = useStyles();

  return (
    <Card className={classes.root}>
      <CardContent>
        <Grid container direction="row" justify="space-evenly">
          <Grid item sx={12} sm={10}>
            <Typography variant="h6">
              {index} - {title}
            </Typography>
            <Typography variant="subtitle2">
              Autori: {authors.join(", ")}
            </Typography>
            <Typography variant="subtitle2">
              <LocalOfferIcon/> {tags.join(", ")}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={2}>
            <IconButton aria-label="add to favorites">
              <a href={`/data/${file}`} download={file}>
                <GetAppIcon />
              </a>
            </IconButton>
            <IconButton aria-label="share">
              <a href={`/data/${file}`} target="_blank">
                <LaunchIcon />
              </a>
            </IconButton>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
